var User = require("./popular/user");
var Feed = require("./popular/feed");

function Popular(app, companyId){
	var self = this;
	self.app = app;
	self.companyId = companyId;

}

Popular.prototype.user = function(){
	var self = this;
	return new User(self.app, self.companyId);
};

Popular.prototype.feed = function(){
	var self = this;
	return new Feed(self.app, self.companyId);
}

module.exports = Popular;